import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { PISectionInput } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingsPageStyles'
import { GRID_CONFIG } from '../utils/patientFormConfig'
import { ArrayFormField } from './FormField'
import { usePatientFormI18n } from '../utils/patientFormI18n'

export const PatientAlternativeEmails = ({
  alternativeEmails = [],
  onAdd,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
  label = 'Alternate Email',
  helperText = '',
  gridConfig = GRID_CONFIG,
}) => {
  const { copy } = usePatientFormI18n()

  const renderAlternativeEmail = (email, index, { onUpdate, onRemove, disabled }) => {
    const validation = validationHook?.getAlternativeEmailValidation(index)

    return (
      <div
        key={index}
        className="d-flex align-items-start gap-2 mb-2"
        style={{ width: '100%', flexWrap: 'wrap' }}
      >
        <div style={{ flex: '1 1 220px', minWidth: 0 }}>
          <div className="d-flex flex-column">
            <PISectionInput
              type="email"
              disabled={disabled}
              placeholder={copy.alternateEmailPlaceholder}
              value={email || ''}
              onChange={(event) => {
                if (!disabled) {
                  onUpdate(index, event.target.value.trim())
                }
              }}
              style={{
                width: '100%',
                minHeight: '40px',
                boxSizing: 'border-box',
                fontSize: '14px',
              }}
            />
            {validation?.showError && (
              <small className="text-danger">{validation.errorMessage}</small>
            )}
          </div>
        </div>

        <DeleteOutlineIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
            marginTop: '10px',
          }}
          onClick={() => {
            if (!disabled) {
              onRemove(index)
            }
          }}
        />
      </div>
    )
  }

  return (
    <ArrayFormField
      label={label}
      helperText={helperText}
      items={alternativeEmails}
      onAdd={editMode ? onAdd : undefined}
      onRemove={editMode ? onRemove : undefined}
      onUpdate={editMode ? onUpdate : undefined}
      renderItem={renderAlternativeEmail}
      disabled={!editMode}
      gridConfig={gridConfig}
      AddIcon={AddCircleOutlineIcon}
    />
  )
}

export default PatientAlternativeEmails
